const groupFooterColumnFields = (fields) => {
  const titleField = fields.find((field) => field.key === 'title') || null;
  const linkGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`link-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `link-${index}-label`)) {
      break;
    }

    linkGroups.push({ index, fields: groupFields });
  }

  return { titleField, linkGroups };
};

export default groupFooterColumnFields;
